// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Erx0","panel":"styles_panel__1NUSl","error":"styles_error__3QMDu"};